import { Party } from './party';
import { Abstract } from './abstract';
import { CivilCase } from './../civil-case';
import { SafeJSON } from './../../shared/safe-json';

export class ServiceOfDocuments {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
     }
    getKey(): string {
        return this.key;
    }
    getPartyCode(): string {
        return SafeJSON.getWithDefault('partyRef', this.json);
    }
    getPartyNameByPartyRef(civilCase: CivilCase): string {
        const party = civilCase.getpartyMap().get(this.getPartyCode());
        if (party === undefined) {
            return '-';
        }
        return party.getName();
    }
    getTypeOfServedDocument(civilCase: CivilCase): string {
        const field = SafeJSON.getWithDefault('serviceTypeDesc', this.json);
        if (field === '-') {
            return '-';
        }
        return field;
    }
    getTypeOfServedDocumentForAbstracts(civilCase: CivilCase): string {
        const abstractRef = SafeJSON.get('abstractRef', this.json);
        if (abstractRef === '') {
            return '';
        }
        const abstract: Abstract = civilCase.getAbstractByKey(abstractRef);
        if (abstract === undefined) {
            return '';
        }
        return abstract.getAbstractSectionTitle(true) + ' ' + abstract.getAbstractJudgmentNumber();
    }
    getIssuedOnDate(): string {
        return SafeJSON.get('issueDateTime', this.json);
    }
    getStatusOfService(): string {
        const statusReasonReturn = SafeJSON.getWithDefault('serviceReasonReturnedDesc', this.json);
        if (statusReasonReturn && (statusReasonReturn.indexOf('- OTHER') >= 0)) {
           return statusReasonReturn + ' (' + SafeJSON.getWithDefault('otherReasonReturnedDesc', this.json) + ')';
        }
        return statusReasonReturn;
    }
    getMethodOfService(): string {
        return SafeJSON.getWithDefault('serviceVehicleDesc', this.json);
    }
    getServedOnDate(): string {
        return SafeJSON.get('serveDateTime', this.json);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-sections/serviceOfDocuments.ts